import React from 'react';
import { NavLink, useNavigate } from 'react-router-dom';
import { useSidebar } from './SidebarContext';

export default function Sidebar() {
  const navigate = useNavigate();
  const enseignant = JSON.parse(localStorage.getItem('enseignant') || '{}');
  const { open, close } = useSidebar();

  const handleLogout = () => {
    localStorage.removeItem('token');
    localStorage.removeItem('enseignant');
    navigate('/login');
  };

  return (
    <nav className={`sidebar${open ? ' open' : ''}`}>
      <div className="sidebar-brand d-flex align-items-start justify-content-between">
        <div>
          <div className="d-flex align-items-center gap-2 mb-1">
            <div style={{
              width: 32, height: 32, borderRadius: 8,
              background: '#066ac9', display: 'flex',
              alignItems: 'center', justifyContent: 'center'
            }}>
              <i className="bi bi-mortarboard-fill text-white" style={{ fontSize: '1rem' }}></i>
            </div>
            <h5 className="mb-0">Suivi Élèves</h5>
          </div>
          <small>{enseignant.nom || 'Enseignant'}</small>
        </div>
        <button className="sidebar-close-btn d-md-none" onClick={close} aria-label="Fermer le menu">
          <i className="bi bi-x-lg"></i>
        </button>
      </div>

      <div className="sidebar-nav">
        <div className="sidebar-section-title">Principal</div>

        <NavLink to="/dashboard" onClick={close} className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`}>
          <i className="bi bi-house-fill"></i> Tableau de bord
        </NavLink>

        <NavLink to="/classes" onClick={close} className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`}>
          <i className="bi bi-people-fill"></i> Classes
        </NavLink>

        <div className="sidebar-section-title">Formulaires</div>

        <NavLink to="/formulaire/creer" onClick={close} className={({ isActive }) => `sidebar-link${isActive ? ' active' : ''}`}>
          <i className="bi bi-plus-circle-fill"></i> Créer un formulaire
        </NavLink>

        <div className="sidebar-section-title mt-auto">Compte</div>
      </div>

      <div style={{ padding: '12px 0', borderTop: '1px solid rgba(255,255,255,0.08)' }}>
        <button
          onClick={handleLogout}
          className="sidebar-link w-100 border-0 bg-transparent text-start"
          style={{ cursor: 'pointer' }}
        >
          <i className="bi bi-box-arrow-left"></i> Déconnexion
        </button>
      </div>
    </nav>
  );
}
